import axios, { type AxiosError } from 'axios';

axios.defaults.withCredentials = true;

export const xhr = axios.create({

});

// const token = localStorage.getItem('token');

xhr.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');

  if (token) {
    config.headers.set('Authorization', `Token ${token}`);
  }

  return config;
});

xhr.interceptors.response.use(
  (response) => {
    return response;
  },
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      delete xhr.defaults.headers.common['Authorization'];
      // window.location.reload();
      // window.location.replace(window.location.origin);
    }

    return Promise.reject(error);
  }
);

export default xhr;
